import axios from "axios";
import type { UserBadgeProgress } from "@/modules/learningCenter/features/BadgeManagement/types/badgeAward.types";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

/**
 * Fetch user badge progress (aggregated statistics)
 *
 * @param userId - User ID
 * @returns User badge progress data
 */
export const fetchUserBadgeProgress = async (
  userId: string,
): Promise<UserBadgeProgress> => {
  const response = await axios.get<UserBadgeProgress>(
    `${API_BASE_URL}/badges/users/${userId}/progress`,
  );
  return response.data;
};

export default fetchUserBadgeProgress;
